// extracted by mini-css-extract-plugin
export default {"option":"SelectOption-module__option--wJAZ8"};